/* eslint-disable react/no-did-mount-set-state */
import React, { Component } from 'react'
import PropTypes from 'prop-types'
import arrowDownIcon from '~/assets/icon-arrow-down.svg'
import Module from '~/components/Module'
import SVG from '~/components/SVG'
import { universalOpenUrl } from '~/utils'
import styles from './index.css'

/**
 * 带展开功能的通用ListComponent
 */
export default class ExpandableList extends Component {
  static propTypes = {
    /* eslint-disable */
    icon: PropTypes.object.isRequired,
    headerText: PropTypes.string.isRequired,
    renderItem: PropTypes.func.isRequired,
  }

  state = {
    expanded: false,
    showData: [],
    listData: [],
  }

  componentDidMount() {
    const { listData } = this.props
    this.setState({
      showData: listData.slice(0, 3),
      listData,
    })
  }

  handleClick = url => () => universalOpenUrl(url)

  changeExpanded = () => {
    const { expanded, listData } = this.state
    this.setState({
      expanded: !expanded,
      showData: expanded ? listData.slice(0, 3) : listData,
    })
  }

  render() {
    const { showData, expanded, listData } = this.state
    const { icon, headerText, renderItem } = this.props
    if (!listData) {
      return null
    }

    return (
      <Module
        headerIcon={<SVG src={icon} width={14} height={14} fill="#0084ff" />}
        headerText={headerText}
      >
        {showData.map(item => renderItem(item, this.handleClick))}
        {listData.length > 3 && (
          <div
            className={
              expanded ? styles.textShrinkButton : styles.textExpandButton
            }
            onClick={this.changeExpanded}
          >
            {expanded ? '收起' : '展开更多'}
            <SVG src={arrowDownIcon} width={9} height={5} />
          </div>
        )}
      </Module>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/ExpandableList/index.js